<script setup lang="ts">
import BrandingSlider from "@/core/interfaces/laboratory/BrandingSlider";
import {Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious} from "@/core/components/ui/carousel";

defineProps<{
    slider: BrandingSlider;
}>();
</script>

<template>
  <div class="w-full">
    <Carousel
      v-if="slider.slides && slider.slides.length > 0"
      :opts="{
        align: 'start',
        loop: true,
      }"
      class="w-full max-w-6xl mx-auto"
    >
      <CarouselContent class="-ml-2 md:-ml-4">
        <CarouselItem
          v-for="(slide, index) in slider.slides"
          :key="`slide-${index}`"
        >
          <div class="relative group">
            <div class="bg-white rounded-lg shadow-md">
              <div class="relative aspect-video bg-gray-100 overflow-hidden rounded-md">
                <img
                  v-if="slide.file?.renderPath"
                  :src="slide.file.renderPath"
                  :alt="slide.title || `Slide ${index + 1}`"
                  class="w-full h-full object-cover"
                  loading="lazy"
                >

                <div class="absolute top-2 right-2 bg-black bg-opacity-50 text-white text-xs px-2 py-1 rounded">
                  {{ index + 1 }} / {{ slider.slides.length }}
                </div>
              </div>
            </div>
          </div>
        </CarouselItem>
      </CarouselContent>

      <CarouselPrevious class="left-2" />
      <CarouselNext class="right-2" />
    </Carousel>
  </div>
</template>

<style scoped>
:deep(.carousel-previous) {
    left: 0.5rem;
}

:deep(.carousel-next) {
    right: 0.5rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .aspect-video {
        aspect-ratio: 4 / 3;
    }
}
</style>
